import dayjs from "dayjs";


export const getOrbitParamPayload = (orbitId?: any, maps?: any,from?:any) => {

  return `${
    orbitId ? `id=${orbitId}&maps=${maps}&fr=${from}` : ""
  }`;
};

export const getPlanetParamPaylad  = (timeLine?: any, doc?: any,from?:any) => {
  return `${`timeLine=${timeLine ? "1" : "0"}&doc=${doc ? "1" : "0"}&fr=${from}`}`;
};


export const setQueryParams = (param: string = "") => {
  let newurl = `${getCurrentLocation()}${param ? "?" + param : ""}`;
  window.history.pushState({ path: newurl }, "", newurl);
};

export const getCurrentLocation = (withParam = false) => {
  const searchParams = new URLSearchParams(window.location.search).toString();
  if (!withParam) {
    return window.location.origin + window.location.pathname === "/"
      ? ""
      : window.location.pathname;
  } else {
    return (
      window.location.origin +
      window.location.pathname +
      "?" +
      searchParams.toString()
    );
  }
};


export const getDashBoardParamPayload = (selectedOrbit?: any, maps?: any) => {
  return `${
    selectedOrbit ? `id=${selectedOrbit}&maps=${maps ? "1" : "0"}` : ""
  }`;
};

export const communityParamPayload = (timeLine?: any, doc?: any) => {
  return `${`timeLine=${timeLine ? "1" : "0"}&doc=${doc ? "1" : "0"}`}`;
};




export const orbitParamValue = (searchParams: any,mode?:any) => {
  
  return {
    selectedOrbit: searchParams.get("id") ? Number(searchParams.get("id")) : null,
    maps: Number(searchParams.get("maps")),
    fr: searchParams.get("fr") ? searchParams.get("fr") : null,
  }
};

export const adminParamValue = (searchParams: any,mode?:any) => {
  
  return {

    fr: searchParams.get("fr") ? searchParams.get("fr") : null,
    
  }
};

export   const getTime = (time: any,format='HH:mm') => {
    return `${dayjs(time).format(format)}`
  };